import { RecordOf } from '@opengov/compose-app/immutable';
import {
  IOgqlColumn,
  IOgqlJobResult,
  IOgqlView,
  IOgqlViewCapabilities,
  IOgqlViewDetail,
  IQueryState
} from '@opengov/ogql-types';

export const QueryState = RecordOf<IQueryState>({
  id: null,
  queryType: null,
  viewId: null,
  version: null,
  queryString: null,
  queryParams: null,
  result: null,
  fastReturn: false
});

export const OgqlJobResult = RecordOf<IOgqlJobResult>({
  id: null,
  state: null,
  timestamps: {
    createdAt: null,
    startedAt: null,
    finishedAt: null
  },
  jobResult: {
    data: null,
    query: null,
    columns: null,
    version: null,
    viewId: null,
    pagination: {
      next: {
        query: null,
        version: null,
        viewId: null
      }
    }
  }
});

export const OgqlColumn = RecordOf<IOgqlColumn>({
  name: null,
  type: null,
  metadata: {
    tags: {
      hidden: null
    },
    facts: {
      distinctCount: null,
      minimum: null,
      maximum: null
    }
  },
  displayName: null,
  semanticTypes: null
});

const CapabilitiesRecord = RecordOf<IOgqlViewCapabilities>({
  export: {
    exportable: false,
    maxExportRows: 0
  },
  groupBy: [],
  orderBy: []
});

export const OgqlViewDetailRecord = RecordOf<IOgqlViewDetail>({
  id: null,
  version: null,
  name: null,
  entityId: null,
  source: null,
  columns: [],
  capabilities: CapabilitiesRecord(),
  dataUpdatedAt: null,
  visible: null
});

export const OgqlViewDetail = (viewDetail?: Partial<IOgqlViewDetail>) =>
  OgqlViewDetailRecord(viewDetail).set(
    'capabilities',
    viewDetail && viewDetail.capabilities ? CapabilitiesRecord(viewDetail.capabilities) : CapabilitiesRecord()
  );

export const OgqlView = RecordOf<IOgqlView>({
  id: null,
  version: null,
  name: null,
  entityId: null,
  source: null,
  dataUpdatedAt: null,
  visible: null
});
